import { render, staticRenderFns } from "./IndoorSetting.vue?vue&type=template&id=b89757be&scoped=true&"
import script from "./IndoorSetting.vue?vue&type=script&lang=js&"
export * from "./IndoorSetting.vue?vue&type=script&lang=js&"
import style0 from "./IndoorSetting.vue?vue&type=style&index=0&id=b89757be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b89757be",
  null
  
)

export default component.exports